import React from 'react'

export default function ViewAuthors() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
        <h5 className='d-flex justify-content-start text-white mb-3'>All Authors</h5>
                <table class="table table-dark rounded rounded-3">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Author Name</th>
                            <th scope="col">Registration Date</th>
                            <th scope="col">Blogs</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>Farhan</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                        </tr>
            </tbody>
            </table>
        </div>
      </div>
    </div>
  )
}
